export const featureToggles = {
  plantingWindowHighlight: false,
};
